// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle
import { section, grayColor } from 'styles/jss/original/base';

import imagesStyles from 'styles/jss/nextjs-material-kit-pro/imagesStyles.js';

const styles = {
  ...imagesStyles,
  section: {
    ...section,
    padding: '70px 0px'
  },
  imageGalleryWrapper: {
    textAlign: 'center',
    '& .image-gallery-slide img': {
      borderRadius: '3px',
      height: 'auto',
      border: '1px solid #fff'
    },
    '& .image-gallery-swipe': {
      margin: '0px',
      overflow: 'hidden',
      width: '100%',
      height: 'auto',
      textAlign: 'center'
    },
    '& .image-gallery-thumbnails > .image-gallery-thumbnails-container .image-gallery-thumbnail': {
      '&.active > .image-gallery-thumbnail-inner': {
        opacity: '1',
        borderColor: grayColor[6]
      },
      '& > .image-gallery-thumbnail-inner': {
        width: '90%',
        margin: '0 auto',
        padding: '0',
        display: 'block',
        border: '1px solid transparent',
        background: 'transparent',
        borderRadius: '2px',
        opacity: '.8'
      },
      '& > .image-gallery-thumbnail-inner img': {
        borderRadius: '3px',
        width: '100%',
        height: 'auto',
        textAlign: 'center'
      }
    },
    '& .image-gallery-svg': {
      display: 'none'
    }
  },
  imgLoading: {
    width: '128px',
    padding: '100px 0'
  }
};

export default styles;
